import { ReactNode, useContext } from 'react';
import { Typography } from '@mildang/mui';
import { DocumentContext, generateVariantValues } from './DocumentContext';

interface NestedItem {
  items?: NestedItem[];
  type?: 'ordered' | 'unordered';
  text?: ReactNode;
}

interface NestedListProps extends NestedItem {
  items: NestedItem[];
}

const NestedList = ({ items, text, type }: NestedListProps) => {
  const createList = (item: NestedItem) => {
    if (!item.items) {
      return null;
    }

    if (item.type === 'ordered') {
      return (
        <ol>
          {item.items.map((item: NestedItem, index) => {
            return (
              <li key={index}>
                {item.text}
                {createList(item)}
              </li>
            );
          })}
        </ol>
      );
    }
    return (
      <ul>
        {item.items.map((item: NestedItem, index) => {
          return (
            <li key={index}>
              {item.text}
              {createList(item)}
            </li>
          );
        })}
      </ul>
    );
  };

  const { variant } = useContext(DocumentContext);

  return (
    <Typography
      component="div"
      variant={generateVariantValues({
        screen: 'body1' as const,
        dialog: 'body2' as const,
      })(variant)}
    >
      {createList({ items, text, type })}
    </Typography>
  );
};

export default NestedList;
